import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';

// Icons
import AssessmentIcon from '@mui/icons-material/Assessment';
import SendIcon from '@mui/icons-material/Send';
import CancelIcon from '@mui/icons-material/Cancel';

const AiAssessmentProposalCard = ({
  proposal, // The assessment proposal object with assessmentDetails and originalAiText
  onForward, // Handler for "Forward to Client"
  onReject, // Handler for "Reject" button
  actionLoading,
  actionError,
  onClearError, // Function to clear the error message
}) => {
  if (!proposal || !proposal.assessmentDetails) {
    return null;
  }

  const { assessmentDetails, originalAiText } = proposal;

  return (
    <Paper variant="outlined" sx={{ p: 1.5, mb: 1, bgcolor: 'info.light', borderColor: 'info.main', flexShrink: 0 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="subtitle2" sx={{ color: 'info.darker', display: 'flex', alignItems: 'center' }}>
          <AssessmentIcon fontSize="inherit" sx={{ mr: 0.5 }} /> AI Proposed Assessment:
        </Typography>
        <Box>
          <Button 
            size="small" 
            variant="contained" 
            color="primary" 
            sx={{ mr: 1 }} 
            onClick={onForward} 
            disabled={actionLoading}
            startIcon={actionLoading ? <CircularProgress size={14} color="inherit" /> : <SendIcon />}
          >
            Forward to Client
          </Button>
          <Button 
            size="small" 
            color="error" 
            onClick={onReject} 
            disabled={actionLoading}
            startIcon={<CancelIcon />}
          >
            Reject
          </Button>
        </Box>
      </Box>
      
      {actionError && <Alert severity="error" sx={{ my: 1 }} onClose={onClearError}>{actionError}</Alert>}
      
      {originalAiText && (
        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', color: 'info.darker', fontStyle: 'italic', mb: 1 }}>
          AI says: "{originalAiText}"
        </Typography>
      )}
      
      <Typography variant="body1" sx={{ color: 'info.darker', fontWeight: 'bold' }}>
        Assessment: {assessmentDetails.testName}
      </Typography>
      
      {assessmentDetails.testDescription && (
        <Typography variant="body2" sx={{ color: 'info.darker', mt: 0.5 }}>
          {assessmentDetails.testDescription}
        </Typography>
      )}
      
      <Typography variant="caption" sx={{ color: 'info.darker', display: 'block', mt: 0.5 }}>
        Test Key: {assessmentDetails.testKey}
      </Typography>
    </Paper>
  );
};

export default AiAssessmentProposalCard;